export const BILLING_TIME_ZONE = "America/Bogota";

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

const dayFormatter = new Intl.DateTimeFormat("en-CA", {
  timeZone: BILLING_TIME_ZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

export function bogotaDay(value: string | Date | null | undefined): string | null {
  if (!value) return null;
  if (typeof value === "string" && DATE_ONLY.test(value)) return value;
  const date = typeof value === "string" ? new Date(value) : value;
  if (Number.isNaN(date.getTime())) return null;
  return dayFormatter.format(date);
}

export function bogotaDayStart(day: string | null | undefined): string | null {
  if (!day) return null;
  const start = new Date(`${day.slice(0, 10)}T00:00:00-05:00`);
  return Number.isNaN(start.getTime()) ? null : start.toISOString();
}

export function toBogotaDayStart(value: string | Date | null | undefined): string | null {
  return bogotaDayStart(bogotaDay(value));
}

const DAY_MS = 24 * 60 * 60 * 1000;

export function bogotaDaysOverdue(
  nextBillingDate: string | Date | null | undefined,
  now: Date = new Date(),
): number | null {
  const due = bogotaDay(nextBillingDate);
  const today = bogotaDay(now);
  if (!due || !today) return null;
  return Math.round((Date.parse(`${today}T00:00:00Z`) - Date.parse(`${due}T00:00:00Z`)) / DAY_MS);
}

export function graceExpired(daysOverdue: number | null, graceDays: number): boolean {
  return daysOverdue !== null && daysOverdue > graceDays;
}
